import { render, staticRenderFns } from "./AddDocumentDirectory.vue?vue&type=template&id=4b8a7475&"
import script from "./AddDocumentDirectory.vue?vue&type=script&lang=js&"
export * from "./AddDocumentDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports